export const columnDefs = [


    {
        headerName: 'key1',
        field: 'key1',

        hide: true,
    },
    {
        headerName: 'category',
        field: 'category',

        hide: true,
    },
    {
        checkboxSelection: true,
        headerName: '',
        field: 'value',
        filterParams: {
            defaultOption: 'startsWith',
        },

    },
    // 1ere sous catégorie
];

// "key":273,"value":"11 VITAMINES","category":1}

export const defaultColDef = {
    suppressMovable: true,
    sortable: true,
    editable: true,
    // cellEditor: 'agLargeTextCellEditor',
    maxLength: 255,
    flex: 1,
    // filter stuff
    filter: true,
    floatingFilter: true,
    // suppressMenu: true,
    // end of filter stuff
    minWidth: 100,
    // resizable: true,
    // tooltipComponent: 'customTooltip',
    filterParams: {
        newRowsAction: 'keep',
        // buttons: ['apply', 'clear'],
    },
    resizable: true,
    cellClass: 'cell-wrap-text',
    autoHeight: true
};